// extracted by mini-css-extract-plugin
module.exports = {"lunbo":"lunbo-1_Y0ffLY","dotCurrent":"dotCurrent-D8RSknfH","box":"box-2QHmgT-x","image":"image-KZicuwYf","link":"link-1sBICVOA"};